import {
    IVincularTiposDocumentoPorEtapa,
    ListarTiposDocumento,
    ListarTiposDocumentoEtapaInterface,
} from "../../../../Interfaces/Geral/GestaoDeCadastro/TipoDocumentoPorEtapa/TipoDocumentoPorEtapa";
import Axios from "../../../Config/API";
import Service from "../../../Service";

export async function ListarTiposDocumentoEtapaCategoriaAtendimentoPorCategoriaService(
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: number,
    FL_DINAMICO: boolean,
    ID_ETAPA_TIPO_CASO: number
) {
    return Service(
        Axios.get<Array<ListarTiposDocumentoEtapaInterface>>(
            `/home/tipodocumentoetapatipocaso/listartiposdocumentoetapacategoriaatendimentoporcategoria?FL_DINAMICO=${FL_DINAMICO}&ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO=${ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO}&ID_ETAPA_TIPO_CASO=${ID_ETAPA_TIPO_CASO}`
        )
    );
}
export async function VincularDocumentoPorEtapaService(
    requestBody: IVincularTiposDocumentoPorEtapa
) {
    return Service(
        Axios.post(
            `/home/tipodocumentoetapatipocaso/vinculardocumentoporetapa`,
            requestBody
        )
    );
}
export async function ListarTiposDeDocumentoService() {
    return Service(
        Axios.get<Array<ListarTiposDocumento>>(
            `/home/tipodocumentoetapatipocaso/listartiposdocumentos`
        )
    );
}
export async function DesvincularDocumentoPorEtapaService(
    idTipoDocumentoEtapaTipoCaso: number
) {
    return Service(
        Axios.delete<Array<ListarTiposDocumentoEtapaInterface>>(
            `home/tipodocumentoetapatipocaso/desvinculardocumentoporetapa?idTipoDocumentoEtapaTipoCaso=${idTipoDocumentoEtapaTipoCaso}`
        )
    );
}
export async function EditarDocumentoPorEtapaService() {
    return Service(
        Axios.put<Array<ListarTiposDocumentoEtapaInterface>>(
            `/home/tipodocumentoetapatipocaso/editardocumentoporetapa`
        )
    );
}

export async function ListEtapasPorCategoriaAtendimentoETipoCasoService(
    ID_CATEGORIA_ATENDIMENTO: number,
    ID_TIPO_CASO: number
) {
    return Service(
        Axios.get<Array<ListarTiposDocumentoEtapaInterface>>(
            `/home/etapacategoriaatendimento/listetapasporcategoriaatendimentoetipocaso?ID_CATEGORIA_ATENDIMENTO=${ID_CATEGORIA_ATENDIMENTO}&ID_TIPO_CASO=${ID_TIPO_CASO}`
        )
    );
}
export async function ListartiposdocumentoetapatipocasoecategoriaatendimentoService() {
    return Service(
        Axios.get<Array<IVincularTiposDocumentoPorEtapa>>(
            `/home/tipodocumentoetapatipocaso/listartiposdocumentoetapatipocasoecategoriaatendimento`
        )
    );
}
